import React, { useState } from 'react'
import { Grid, TextField, Typography, Box, Button } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { has, unset } from 'lodash'

import {
  publishClickedCancelEditTeamInfo,
  publishClickedEditTeamInfo,
} from '../../../util/events/teamsEventPublishers'
import CardActionButton from './CardActionButton'
import CardWrapper from './CardWrapper'

export default function CardTeamDetails({ team, loading, onSubmit }) {
  const [editMode, setEditMode] = useState(false)
  const [updatedTeam, setUpdatedTeam] = useState({})

  const toggleEdit = () => {
    if (editMode) {
      setEditMode(false)
      setUpdatedTeam({})
      publishClickedCancelEditTeamInfo()
    } else {
      setEditMode(true)
      publishClickedEditTeamInfo()
    }
  }

  const updateField = e => {
    if (e) {
      e.preventDefault()
    }
    const { name, value } = e.target

    //remove from pending changes if same as saved value
    if (has(updatedTeam, name) && team[name] === value) {
      const copiedChanges = JSON.parse(JSON.stringify(updatedTeam))
      unset(copiedChanges, name)
      setUpdatedTeam(copiedChanges)
    } else {
      setUpdatedTeam({
        ...updatedTeam,
        [name]: value,
      })
    }
  }

  const submitUpdate = () => {
    setEditMode(false)
    onSubmit(updatedTeam)
    setUpdatedTeam({})
  }

  if (loading) {
    return (
      <CardWrapper>
        <Typography variant="h6">Team Information</Typography>
        <Skeleton height={50} />
      </CardWrapper>
    )
  }

  return (
    <CardWrapper>
      <CardActionButton name={editMode ? 'Cancel' : 'Edit'} onClick={toggleEdit} />
      <Typography variant="h6">Team Information</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Box>
            <Typography variant="overline" color="textSecondary">
              Name
            </Typography>
          </Box>
          {!editMode && <Typography variant="body1">{team.name}</Typography>}
          {editMode && (
            <TextField
              name="name"
              fullWidth
              size="small"
              variant="outlined"
              value={updatedTeam.name !== undefined ? updatedTeam.name : team.name}
              onChange={updateField}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box>
            <Typography variant="overline" color="textSecondary">
              Domain
            </Typography>
          </Box>
          {!editMode && <Typography variant="body1">{team.emailDomain}</Typography>}
          {editMode && (
            <TextField
              name="emailDomain"
              fullWidth
              size="small"
              variant="outlined"
              value={
                updatedTeam.emailDomain !== undefined ? updatedTeam.emailDomain : team.emailDomain
              }
              onChange={updateField}
            />
          )}
        </Grid>
        {editMode && (
          <Grid item xs={12}>
            <Box display="flex" mt={2}>
              <Box flex="1 0 0" />
              <Button
                variant="outlined"
                color="primary"
                onClick={submitUpdate}
                disabled={!updatedTeam.name && !updatedTeam.emailDomain}
              >
                Update
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </CardWrapper>
  )
}
